import React from 'react';
import { motion } from 'framer-motion';

const SoftvativeHeader = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex justify-center mb-8"
    >
      <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-3 border border-white/20">
        {/* Softvative Logo */}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-purple-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">S</span>
          </div>
          <span className="text-xl font-bold text-white">Softvative</span>
        </div>
        
        {/* Separator */}
        <div className="w-px h-6 bg-white/20"></div>
        
        {/* Chess Master Title */}
        <div className="text-lg font-semibold text-gray-300">
          Chess Master
        </div>
      </div>
    </motion.div>
  );
};

export default SoftvativeHeader;